import { Directive } from '@angular/core';

@Directive({
  selector: 'ly-tab-label, [ly-tab-label]'
})
export class LyTabLabelDirective { }
